import theme from '@/style';
import React, {useMemo} from 'react';
import Tabs from '@/components/basic/tab';
import {View} from 'react-native';
import Text from '@/components/basic/text';
import LinearGradient from '@/components/basic/linear-gradient/linear-gradient';

export interface CasinoTabsProps {
  tabOptions: {label: string; value: string}[];
  value: string;
  onChange: (value: string) => void;
}

const CasinoTabs: React.FC<CasinoTabsProps> = ({
  tabOptions,
  value,
  onChange,
}) => {
  const resultTabOptions = useMemo(() => {
    return tabOptions.map(({label, value: innerValue}) => ({
      // eslint-disable-next-line react/no-unstable-nested-components
      label: (active: boolean) => (
        <View
          style={[
            theme.flex.row,
            theme.flex.center,
            theme.padding.lrs,
            theme.padding.tbxxs,
            theme.borderRadius.xs,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              backgroundColor: active ? '#F6F7FB' : theme.basicColor.white,
              height: 24,
            },
          ]}>
          <Text
            main={active}
            accent={!active}
            blod={active}
            calc
            style={theme.margin.leftxxs}>
            {label}
          </Text>
        </View>
      ),
      value: innerValue,
    }));
  }, [tabOptions]);
  return (
    <LinearGradient
      start={{x: 0, y: 0}}
      end={{x: 0, y: 1}}
      colors={['#fff', 'rgba(255, 255, 255, 0.00)']}>
      <Tabs
        style={[theme.background.transparent]}
        tabOptions={resultTabOptions}
        value={value}
        onChange={onChange}
        innerGap={theme.paddingSize.xxs}
        noShadow
      />
    </LinearGradient>
  );
};

export default CasinoTabs;
